<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Mail Open" class="d-icon d-icon--mail-open" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 12"><path fill="currentColor" fill-rule="evenodd" d="M6.5 1.5a.5.5 0 0 0-.3.1l-4 3a.5.5 0 0 0-.14.163l4.192 2.664a.47.47 0 0 0 .496 0h.002l4.19-2.663a.516.516 0 0 0-.141-.165h-.002L6.8 1.6a.5.5 0 0 0-.3-.1ZM11 5.91 7.28 8.274a1.47 1.47 0 0 1-1.56 0l-.003-.002L2 5.91V10a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V5.91ZM5.6.8a1.5 1.5 0 0 1 1.8 0l4.002 3.002c.372.282.598.723.598 1.198v5a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 1 10V5a1.5 1.5 0 0 1 .6-1.2l4-3Z" clip-rule="evenodd"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconMailOpen',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
